/* eslint-disable */
// ゲーム
let game;

// 背景オブジェクト
let bgImg;

// 入力イベント
let inputCursors;
let inputPointer;

// オープニングメッセージオブジェクトリスト
let openingMsg = [];
// オープニングシーンのtweenを管理
let openingMsgTween = [];

// テキストオブジェクト
let messagesTextObj = [];
let messagesTextNextObj = [];
// 現在の行数
let currentLine = 0;

// キャラオブジェクト
// let spriteList;
let char01;
let char02;
let char03;
let char04;
let char05;
let char06;

// 敵オブジェクト
let enemy1;
let enemy2;
let enemy3;

// メッセージ
let message;

// bgmオブジェクト
let bgm;

let se;

// seオブジェクト
let messageSe1;
let messageSe2;
let attackSe;
let damageSe;

// メッセージウィンドウオブジェクト
let msgWindow;

let char1StatusWindow;
let char2StatusWindow;
let char3StatusWindow;
let char4StatusWindow;

// メッセージオブジェクト
let msgTitle;

// マンプオブジェクト
let emote;

// コマ送りメッセージインデックス
let messageMoji = 0;

let openingMessageIndex = 0;
let isOpeningMessageText = false;
let isOpeningMessageWait = false;

// ジャンプフラグ
let jumpFlag = false;


// シーン
let gameState;
let gameStateOld = -1;
let sceneState = 0;

// 経過時間（処理のステップを進めるために利用する）
let elapsedTime = 0;
let textElapsedTime = 0;

let isDownMoveAnimStart_01_03 = false;
let isDownMoveAnimStart_02_04 = false;

let statusDeleteElapsedTime = 0;
let statusDeleteCont = 0;

let damageElapsedTime = 0;
let damageCont = 0;
let damage = true;

let isMessageWait = false;

let isClick = false;
let startClick = false;
let endClick = false;

let messageEndFunc = null;

// 次へ▼カーソル点滅処理カウンタ
let blinkFgWait = 0;
let blinkFg = false;

let finishCallback;

export function start(callback) {
    gameState = GameState.initFont;
    
    let config = {
        type  : Phaser.AUTO, // 自動(WEBGLが使えなければCANVASを使う)
        width : SCREEN_WIDTH, // 横幅
        height: SCREEN_HEIGHT, // 高さ
        scale : {
            parent: 'game-container',
        // mode: Phaser.Scale.NONE,
        // mode: Phaser.Scale.CENTER_BOTH ,
        // mode: Phaser.Scale.ENVELOP,
        // mode: Phaser.Scale.CENTER_HORIZONTALLY,
        mode: Phaser.Scale.FIT,
        // mode: Phaser.Scale.RESIZE,
        // width: '100%',
        // height: '100%',
        // autoCenter: Phaser.Scale.CENTER_VERTICALLY  // 中央配置
        // zoom: 1,
        },
        scene: {
            preload: preload, // ゲーム開始前に画像のロード等で呼ぶ関数
            create: create, // 初期化関数
            update: update // ゲーム中定期的に呼ばれる関数
        },
        input: {
            activePointers: 1  // アクティブなポインターの数を設定（デフォルトは1）
        },
        backgroundColor: 0x000000,  // 背景色
        fps: 60
    };
    
    // ゲーム
    game = new Phaser.Game(config);
    finishCallback = callback;
}

export function cancel() {
    destroy();
    if (finishCallback) finishCallback();
}

export function destroy() {
    if(bgm) 
    {
        bgm.stop();
        bgm.destroy();
    }
}

// ブラウザのサイズに合わせて表示位置の調整を行う
let resizeTime = 0;
window.onresize = reportWindowSize;
function reportWindowSize() {
    if (resizeTime > 0) {
        clearTimeout(resizeTime);
    }
    resizeTime = setTimeout(function () {
        let gobj= document.getElementById('game-container');
        const MAX_SCREEN_WIDTH  = 800;
        if ( window.innerWidth > MAX_SCREEN_WIDTH) {
            let waku = document.querySelector(".waku");
            let w = MAX_SCREEN_WIDTH;
            let h = w * SCREEN_HEIGHT / SCREEN_WIDTH;
            waku.style.width  = w + "px";
            waku.style.height = h + "px";
            if( window.innerWidth > window.innerHeight ) {
                let rate = window.innerHeight / h;
                gobj.style.left = (window.innerWidth / 2) + 'px';
                gobj.style.top = (window.innerHeight / 2) + 'px';
            } else {
                let rate = window.innerWidth / w;
                gobj.style.left = (window.innerWidth / 2) + 'px';
                gobj.style.top = (window.innerHeight / 2) + 'px';
            }
        }
        else {
            if( window.innerWidth > window.innerHeight ) {
                let rate = window.innerHeight / SCREEN_HEIGHT;
                gobj.style.left = (window.innerWidth / 2) + ((window.innerWidth - SCREEN_WIDTH * rate) / 2) + 'px';
                gobj.style.top = (window.innerHeight / 2) + 'px';
            } else {
                let rate = window.innerWidth / SCREEN_WIDTH;
                gobj.style.left = (window.innerWidth / 2) + 'px';
                gobj.style.top = (window.innerHeight / 2) + ((window.innerHeight - SCREEN_HEIGHT * rate) / 2) + 'px';
            }
        }
    }, 100);
}
reportWindowSize();

// =========================================================
// 開始前にリソースの読み込みを行う
// =========================================================
function preload ()
{
    // フォントの取得
    this.load.css(FONT,      'css/customFont.css');
    this.load.css(FONT_REAL, 'css/customFont.css');

    // サウンドの取得
    this.load.audio(BGM_OPENING,     BGM_04_PATH);
    this.load.audio(BGM_CASTLE,      BGM_01_PATH);
    this.load.audio(BGM_FIELD,       BGM_02_PATH);
    this.load.audio(BGM_BATTLE,      BGM_03_PATH);
    this.load.audio(SE_ENCOUNTER,    SE_ENCOUNTER_PATH);
    this.load.audio(SE_GAMEOVER,     SE_GAMEOVER_PATH);
    this.load.audio(SE_MESSAGE_01,   SE_MESSAGE_01_PATH);
    this.load.audio(SE_MESSAGE_02,   SE_MESSAGE_02_PATH);
    this.load.audio(SE_STAGE_CHANGE, SE_STAGE_CHANGE_PATH);
    this.load.audio(SE_EXCLAMATION,  SE_EXCLAMATION_PATH);
    this.load.audio(SE_QUESTION,     SE_QUESTION_PATH);
    this.load.audio(SE_STAIRS,       SE_STAIRS_PATH);
    this.load.audio(SE_ESCAPE,       SE_ESCAPE_PATH);
    this.load.audio(SE_ATTACK,       SE_ATTACK_PATH);
    this.load.audio(SE_DAMAGE,       SE_DAMAGE_PATH);
    

    // 画像
    this.load.image(OPENING_BG,        OPENING_BG_PATH);
    this.load.image(CASTLE_WHITE_BG,   CASTLE_WHITE_BG_PATH);
    this.load.image(CASTLE_BG,         CASTLE_BG_PATH);
    this.load.image(FIELD_BG,          FIELD_BG_PATH);
    this.load.image(BATTLE_BG,         BATTLE_BG_PATH);

    this.load.image(BATTLE_STATUS_01,           BATTLE_STATUS_01_PATH);
    this.load.image(BATTLE_STATUS_01_DEATH,     BATTLE_STATUS_01_DEATH_PATH);
    this.load.image(BATTLE_STATUS_02,           BATTLE_STATUS_02_PATH);
    this.load.image(BATTLE_STATUS_03,           BATTLE_STATUS_03_PATH);
    this.load.image(BATTLE_STATUS_04,           BATTLE_STATUS_04_PATH);

    this.load.image(BLOCK,             BLOCK_PATH);

    this.load.image(MESSAGE,           MESSAGE_PATH);

    this.load.image(MONSTER,           MONSTER_PATH);

    // スプレッドシート
    this.load.spritesheet(CHAR_01, CHAR_01_PATH, { frameWidth: FRAME_WIDTH, frameHeight: FRAME_HEIGHT });
    this.load.spritesheet(CHAR_02, CHAR_02_PATH, { frameWidth: FRAME_WIDTH, frameHeight: FRAME_HEIGHT });
    this.load.spritesheet(CHAR_03, CHAR_03_PATH, { frameWidth: FRAME_WIDTH, frameHeight: FRAME_HEIGHT });
    this.load.spritesheet(CHAR_04, CHAR_04_PATH, { frameWidth: FRAME_WIDTH, frameHeight: FRAME_HEIGHT });
    this.load.spritesheet(CHAR_05, CHAR_05_PATH, { frameWidth: FRAME_WIDTH, frameHeight: FRAME_HEIGHT });
    this.load.spritesheet(CHAR_06, CHAR_06_PATH, { frameWidth: FRAME_WIDTH, frameHeight: FRAME_HEIGHT });

    this.load.spritesheet(EMOTE, EMOTE_PATH, { frameWidth: EMOTE_FRAME_WIDTH, frameHeight: EMOTE_FRAME_HEIGHT });
}

// =========================================================
// 初期化
// =========================================================
function create ()
{
    bgImg = this.add.image(SCREEN_WIDTH_CENTER, SCREEN_HEIGHT_CENTER, OPENING_BG_PATH);

    // マウス入力を有効にする
    this.input.mouse.capture = true;

    //  Input Events
    inputCursors = this.input.keyboard.createCursorKeys();

    // キャラアニメ登録
    for (var i = 1; i <= 4; i++) {
        var cname = CHAR_FRONT + i;
        this.anims.create({
            key: DOWN_WALK_ANI[i - 1],
            frames: this.anims.generateFrameNumbers(cname, { start: 0, end: 3 }),
            frameRate: 5,
            repeat: -1
        });
        this.anims.create({
            key: UP_WALK_ANI[i - 1],
            frames: this.anims.generateFrameNumbers(cname, { start: 12, end: 15 }),
            frameRate: 5,
            repeat: -1
        });
    }

    // 左右を2回向き前を向くアニメーション作成
    this.anims.create({
            key: RESTLESS_ANI,
            frames: this.anims.generateFrameNumbers(CHAR_01, { frames: [ 4, 8, 4, 8, 12] }),
            frameRate: 2.5,
        });

    // 下左右下、の順番で振り向くアニメーション
    this.anims.create({
        key: STUNNED_ANI,
        frames: this.anims.generateFrameNumbers(CHAR_01, { frames: [ 0, 4, 8, 0] }),
        frameRate: 1.5,
    });

    // spriteList = new Map();

    // エモート ? の作成
    this.anims.create({
        key: EMOTE_QUESTION,
        frames: this.anims.generateFrameNumbers(EMOTE, { frames: [ 0, 1, 2, 3] }),
        frameRate: 3,
        repeat:-1,
    });

    // エモート ... の作成
    this.anims.create({
        key: EMOTE_DOT,
        frames: this.anims.generateFrameNumbers(EMOTE, { frames: [ 4, 5, 6, 7] }),
        frameRate: 3,
        repeat:-1,
    });

    // エモート ! の作成
    this.anims.create({
        key: EMOTE_EXCLAMATION,
        frames: this.anims.generateFrameNumbers(EMOTE, { frames: [ 8, 9, 10, 11] }),
        frameRate: 3,
        repeat:-1,
    });

    // オープニングを初期化
    openingMessageIndex = 0;
    isOpeningMessageText = true;
    isOpeningMessageWait = false;

    messageSe1 = this.sound.add(SE_MESSAGE_01, {volume: SE_VOLUME});
    messageSe2 = this.sound.add(SE_MESSAGE_02, {volume: SE_VOLUME});
}

// 更新
function update (time, delta)
{
    elapsedTime += delta;

    // 次へ▼カーソル点滅処理
    blinkFgWait += delta;
    if (blinkFgWait > 400) {
        blinkFgWait = 0;
        if (blinkFg) {
            blinkFg = false;
        } else {
            blinkFg = true;
        }
        for (let i = 0; i < 4; i++) {
            let obj = messagesTextNextObj[i];
            if (obj != undefined) {
                obj.alpha = (blinkFg)?1:0;
            }
        }
    }


    // クリック判定取得
    inputPointer = this.input.activePointer;
    if(inputPointer && inputPointer.isDown && !isClick && !startClick)
    {
        //console.log("クリック")
        isClick = true;
        startClick = true;
    }
    else if(inputPointer && !inputPointer.isDown && startClick){
        //console.log("離した")
        startClick = false;
        endClick = true;
    }

	
    // シーンが変わったら、シーン内カウンタを初期化
    if (gameStateOld != gameState) {
        gameStateOld = gameState;
        sceneState = 0;
    }

    if (gameState == GameState.initFont) {
        updateInitFont(this);        
    }
    else if (gameState == GameState.opening) {
        updateOpening(this);        
    }
    else if (gameState == GameState.castle) {
        updateCastle(this,delta);       
    }
    else if (gameState == GameState.field) {
        updateField(this,delta);        
    }
    else if (gameState == GameState.battle) {
        updateBattle(this,delta);        
    }

    isClick = false;
    endClick = false;
}

let lineGroup1 = [];
let lineGroup2 = [];
let lineGroup3 = [];
let lineGroup4 = [];
let lineCnt;
let x1 = 0;
let y1 = 0;
let x2 = 0;
let y2 = 0;
let x3 = 0;
let y3 = 0;
let x4 = 0;
let y4 = 0;

/** 
 * バトルシーンアップデート 
 */
function updateBattle(t,delta)
{
    // 次のメッセージ待ちなら、クリックで進む
    if(isClick && isMessageWait)
    {
        messageEndFunc?.();
        messageEndFunc = null;
        isClick = false;
        isMessageWait = false;
        messageMoji = 0;
        currentLine = 0;
        message = null;
        elapsedTime = 0;
        sceneState++;
    }

    if (sceneState == BattleState.encounter) {
        for( var i = 0; i < 40; i++) {
            lineGroup1[i] = t.add.group({ key: BLOCK, frameQuantity: 24, setXY:{x:-100,y:-100} });
            lineGroup2[i] = t.add.group({ key: BLOCK, frameQuantity: 24, setXY:{x:-100,y:-100} });
            lineGroup3[i] = t.add.group({ key: BLOCK, frameQuantity: 24, setXY:{x:-100,y:-100} });
            lineGroup4[i] = t.add.group({ key: BLOCK, frameQuantity: 24, setXY:{x:-100,y:-100} });
        }

        lineCnt = 0;
        x1 = SCREEN_WIDTH_CENTER + 0;
        y1 = SCREEN_HEIGHT_CENTER - 700;
        x2 = SCREEN_WIDTH_CENTER + 0;
        y2 = SCREEN_HEIGHT_CENTER + 700;
        x3 = SCREEN_WIDTH_CENTER + 700;
        y3 = SCREEN_HEIGHT_CENTER + 0;
        x4 = SCREEN_WIDTH_CENTER - 700;
        y4 = SCREEN_HEIGHT_CENTER + 0;

        sceneState++;
        elapsedTime = 0;
    }
    if (sceneState == BattleState.encounterEffect){
        if (elapsedTime > 10) {
            elapsedTime = 0;

            Phaser.Actions.PlaceOnLine(lineGroup1[lineCnt].getChildren(), new Phaser.Geom.Line(SCREEN_WIDTH_CENTER, SCREEN_HEIGHT_CENTER, x1, y1));
            Phaser.Actions.PlaceOnLine(lineGroup2[lineCnt].getChildren(), new Phaser.Geom.Line(SCREEN_WIDTH_CENTER, SCREEN_HEIGHT_CENTER, x2, y2));
            Phaser.Actions.PlaceOnLine(lineGroup3[lineCnt].getChildren(), new Phaser.Geom.Line(SCREEN_WIDTH_CENTER, SCREEN_HEIGHT_CENTER, x3, y3));
            Phaser.Actions.PlaceOnLine(lineGroup4[lineCnt].getChildren(), new Phaser.Geom.Line(SCREEN_WIDTH_CENTER, SCREEN_HEIGHT_CENTER, x4, y4));

            lineCnt ++;

            x1 += 20;
            y1 += 20;
            x2 -= 20;
            y2 -= 20;
            x3 -= 20;
            y3 += 20;
            x4 += 20;
            y4 -= 20;

            if( y1 > 300) {

                bgImg = t.add.image(SCREEN_WIDTH_CENTER, SCREEN_HEIGHT_CENTER, BATTLE_BG);

                enemy1 = t.add.image(SCREEN_WIDTH_CENTER - 190, SCREEN_HEIGHT_CENTER, MONSTER);
                enemy2 = t.add.image(SCREEN_WIDTH_CENTER, SCREEN_HEIGHT_CENTER, MONSTER);
                enemy3 = t.add.image(SCREEN_WIDTH_CENTER + 190, SCREEN_HEIGHT_CENTER, MONSTER);

                char1StatusWindow = t.add.image(96, 96, BATTLE_STATUS_01);
                char2StatusWindow = t.add.image(96 + 192, 96, BATTLE_STATUS_02);
                char3StatusWindow = t.add.image(96 + 192 * 2, 96, BATTLE_STATUS_03);
                char4StatusWindow = t.add.image(96 + 192 * 3, 96, BATTLE_STATUS_04);

                initMessageWindow(t);

                sceneState++;
                elapsedTime = 0;
            }
        }
    }
    if(sceneState == BattleState.なんと)
    {
        displayText(delta,false,true,() => {

        if(bgm) {
            bgm.stop();
            bgm.destroy();
        }
        bgm = t.sound.add(BGM_BATTLE, {volume: BGM_VOLUME});
        bgm.play({loop:true});

        attackSe = t.sound.add(SE_ATTACK, {volume: SE_VOLUME});
        damageSe = t.sound.add(SE_DAMAGE, {volume: SE_VOLUME});
        });
    }
    if(sceneState == BattleState.やばい)
    {
        displayText(delta);
    }
    if(sceneState == BattleState.ステータス削除)
    {
        if(elapsedTime >= 200)
        {
            statusDeleteElapsedTime += delta;

            if(statusDeleteElapsedTime >= 200)
            {
                if(statusDeleteCont === 0)
                {
                    const escape = t.sound.add(SE_ESCAPE, {volume: SE_VOLUME});
                    escape.play({loop:false})
                    char4StatusWindow.destroy();
                }
                else if(statusDeleteCont === 1)
                {
                    const escape = t.sound.add(SE_ESCAPE, {volume: SE_VOLUME});
                    escape.play({loop:false})
                    char3StatusWindow.destroy();
                }
                else if(statusDeleteCont === 2)
                {
                    const escape = t.sound.add(SE_ESCAPE, {volume: SE_VOLUME});
                    escape.play({loop:false})
                    char2StatusWindow.destroy();

                    sceneState++;
                    elapsedTime = 0;
                }

                statusDeleteCont++;
                statusDeleteElapsedTime = 0;
            }
        }
    }
    if(sceneState == BattleState.ちょ)
    {
        if(elapsedTime >= DEF_STEP_NEXT)
        {
            displayText(delta);
        }
    }
    if(sceneState == BattleState.攻撃)
    {
        displayText(delta);
    }
    if(sceneState == BattleState.画面揺れ)
    {
        if(elapsedTime >= 200)
        {
            damageElapsedTime += delta;

            if(damageElapsedTime >= 200 && damage)
            {
                attackSe.play({loop:false});

                let target = enemy1;
                if(damageCont === 1)
                {
                    target = enemy2
                }
                else if(damageCont === 2)
                {
                    target = enemy3
                }

                var tweenManager = t.tweens;
                tweenManager.add({
                    targets: target,
                    x: '-=10',
                    y: '-=10',
                    alpha: 1,
                    duration: 50,
                    yoyo: true, // アニメーションを繰り返す（元の位置に戻る）
                    repeat: 1,
                });

                damage = false;
                damageElapsedTime = 0;
            }
            else if(damageElapsedTime >= 150 && !damage)
            {
                damageSe.play({loop:false});

                var tweenManager = t.tweens;
                tweenManager.add({
                    targets: [msgWindow,...messagesTextObj,...messagesTextNextObj],
                    x: '-=10',
                    y: '-=10',
                    alpha: 1,
                    duration: 50,
                    yoyo: true, // アニメーションを繰り返す（元の位置に戻る）
                    repeat: 1,
                    onComplete: () => {
                        tweenManager.add({
                            targets: [msgWindow,...messagesTextObj,...messagesTextNextObj],
                            x: '+=10',
                            y: '+=10',
                            alpha: 1,
                            duration: 50,
                            yoyo: true, // アニメーションを繰り返す（元の位置に戻る）
                            repeat: 1
                        });
                    },
                    onCompleteScope: t
                });

                damage = true;
                damageCont++;
                //console.log(" : " + damageCont)
                damageElapsedTime = -500;

                if(damageCont >= 3)
                {
                    sceneState++;
                    elapsedTime = 0;
                }
            }
        }
    }
    if(sceneState == BattleState.ぐぇ)
    {
        if(elapsedTime >= 1000)
        {
            displayText(delta,true,true,()=>{
                char1StatusWindow.destroy();
                char1StatusWindow = t.add.image(96, 96, BATTLE_STATUS_01_DEATH);
            });
        }
    }
    if(sceneState == BattleState.あなたは)
    {
        displayText(delta);
    }
    if (sceneState == BattleState.gameOver) 
    {
        if(bgm) 
        {
            bgm.stop();
            bgm.destroy();
        }
        bgm = t.sound.add(SE_GAMEOVER, {volume: BGM_VOLUME});
        bgm.play({loop:false});

        sceneState++;
        elapsedTime = 0;
    }
    if (sceneState == BattleState.fadeOut) {
        if (elapsedTime > 500) {
            t.cameras.main.fadeOut(1200, 255, 255, 255);

            sceneState++;
            elapsedTime = 0;
        }
    }
    if (sceneState == BattleState.jump) {
        if (elapsedTime > 1500) {
            if (finishCallback) finishCallback();
        }
    }
}

/** 
 * フィールドシーンアップデート 
 */
function updateField(t,delta)
{
    // 次のメッセージ待ちなら、クリックで進む
    if(isClick && isMessageWait)
    {
        messageEndFunc?.();
        messageEndFunc = null;
        isClick = false;
        isMessageWait = false;
        messageMoji = 0;
        currentLine = 0;
        message = null;
        elapsedTime = 0;
        sceneState++;
    }

    if (sceneState == FieldState.init) {

        bgImg = t.add.image(SCREEN_WIDTH_CENTER, SCREEN_HEIGHT_CENTER, FIELD_BG);

        if(bgm)
        {
            bgm.stop();
            bgm.destroy();
        }
        bgm = t.sound.add(BGM_FIELD, {volume: BGM_VOLUME});
        bgm.play({loop:true});

        // 主人公
        char01 = t.add.sprite(SCREEN_WIDTH_CENTER, 215, CHAR_01);

        // 戦士
        char02 = t.add.sprite(SCREEN_WIDTH_CENTER - (FRAME_WIDTH / 2), 287, CHAR_02);
        // 勇者
        char03 = t.add.sprite(SCREEN_WIDTH_CENTER, 287, CHAR_03);
        // 僧侶
        char04 = t.add.sprite(SCREEN_WIDTH_CENTER + (FRAME_WIDTH / 2), 287, CHAR_04);

        char02.setFrame(12);
        char03.setFrame(12);
        char04.setFrame(12);

        sceneState++;
        elapsedTime = 0;
    }
    if(sceneState == FieldState.fadeIn)
    {
        t.cameras.main.fadeIn(2400, 0, 0, 0);

        sceneState++;
        elapsedTime = 0;
    }
    if(sceneState == FieldState.えっ)
    {
        if(elapsedTime >= 2400)
        {
            displayText(delta,false,true,()=>{
                initMessageWindow(t);
            },null);
        }
    }
    if(sceneState == FieldState.娯楽)
    {
        displayText(delta,true,true,() =>{
            emote = t.add.sprite(SCREEN_WIDTH_CENTER, 160, EMOTE);
            emote.anims.play(EMOTE_DOT);
        },null);
    }
    if(sceneState == FieldState.あまり)
    {
        displayText(delta);

    }
    if(sceneState == FieldState.どうやら)
    {
        displayText(delta);
    }
    if(sceneState == FieldState.しかし)
    {
        displayText(delta,true,true,null,() => {
            emote.destroy()
        });
    }
    if(sceneState == FieldState.はい)
    {
        displayText(delta,true,true,null,() => {
            char02.setFrame(0)
        });
    }
    if(sceneState == FieldState.下向く)
    {
        if(char02.y <= 277 || jumpFlag)
        {
            jumpFlag = true;
            char02.y += 1.25;
            
            if(char02.y >= 287)
            {
                char02.y = 287;
                sceneState ++;
                elapsedTime = 0; 
            }
        }
        else{
            char02.y -= 1.25;
        }
    }                    
    if(sceneState == FieldState.そもそも)
    {
        if(elapsedTime >= 200)
        {
            displayText(delta,true,true,()=>{
                char02.setFrame(12);
            },null);
        }
    }
    if(sceneState == FieldState.エルフ)
    {
        displayText(delta);
    }
    if(sceneState == FieldState.魔法使い体当たり)
    {
        char04.x -= 10; 
        sceneState ++;
        elapsedTime = 0;
    }
    if(sceneState == FieldState.跳ねる)
    {
        if(elapsedTime >= 20)
        {
            char03.y -= 5; 
            sceneState ++;
            elapsedTime = 0;
        }
    }
    if(sceneState == FieldState.おい)
    {
        if(elapsedTime >= 180)
        {
            displayText(delta,true,true,() => {
                char04.x += 10; 
                char03.y += 5;
            },null);
        }
    }
    if(sceneState == FieldState.なにか)
    {
        displayText(delta,true,true,() => {
            emote = t.add.sprite(SCREEN_WIDTH_CENTER, 160, EMOTE);
            emote.anims.play(EMOTE_QUESTION);
            const question = t.sound.add(SE_QUESTION, {volume: SE_VOLUME});
            question.play({loop:false})
        },null);
    }
    if(sceneState == FieldState.いやいや)
    {
        displayText(delta,true,true,() => {
            emote.destroy();
        },null);
    }
    if(sceneState == FieldState.囲む)
    {
        msgWindow.destroy();
        msgTitle.destroy();
        messagesTextObj.forEach(element => {
            element.destroy();
        });
        messagesTextObj = [];
        messagesTextNextObj.forEach(element => {
            element.destroy();
        });
        messagesTextNextObj = [];

        sceneState ++;
        elapsedTime = 0; 
    }
    if(sceneState == FieldState.下に歩く)
    {
        if(elapsedTime >= 200)
        {
            if(!isDownMoveAnimStart_01_03)
            {
                isDownMoveAnimStart_01_03 = true;
                char03.anims.play(DOWN_WALK_ANI[2]);
                char01.anims.play(DOWN_WALK_ANI[0]);

            }

            char03.y += 2.88;
            char01.y += 2.88;

            if(char01.y >= 287)
            {
                if(!isDownMoveAnimStart_02_04)
                {
                    isDownMoveAnimStart_02_04 = true;
                    char04.anims.play(DOWN_WALK_ANI[3]);
                    char02.anims.play(DOWN_WALK_ANI[1]);
                }
                char02.y += 2.88;
                char04.y += 2.88; 
            }

            if(char01.y >= 550)
            {
                bgm.stop();
                se = t.sound.add(SE_ENCOUNTER, {volume: SE_VOLUME + 0.2});
                se.play({loop:false});

                sceneState ++;
                elapsedTime = 0; 
            }
        }
    }
    if(sceneState == FieldState.シーン変更)
    {
        gameState = GameState.battle;
    }
}

/** 
 * 城シーンアップデート 
 */
function updateCastle(t,delta)
{
    //console.log("sceneState="+sceneState + " delta="+delta);

    // 次のメッセージ待ちなら、クリックで進む
    if(isClick && isMessageWait)
    {
        messageEndFunc?.();
        messageEndFunc = null;
        isClick = false;
        isMessageWait = false;
        messageMoji = 0;
        currentLine = 0;
        message = null;
        elapsedTime = 0;
        sceneState++;
    }

    if (sceneState == CastleState.init) {
        bgImg?.destroy();
        bgImg = t.add.image(SCREEN_WIDTH_CENTER, SCREEN_HEIGHT_CENTER, CASTLE_WHITE_BG);

        t.cameras.main.fadeIn(0, 255, 255, 255);

        initMessageWindow(t);

        sceneState ++;
        elapsedTime = 0;
    }
    if(sceneState == CastleState.召喚)
    {
        displayText(delta,false);
    }
    if(sceneState == CastleState.無事)
    {
        displayText(delta);
    }
    if(sceneState == CastleState.okok)
    {
        displayText(delta);
    }
    if(sceneState == CastleState.エルフ)
    {
        displayText(delta);
    }
    if(sceneState == CastleState.しかし)
    {
        displayText(delta);
    }
    if(sceneState == CastleState.ええい)
    {
        displayText(delta,true,true,null,() => {
            for (let i = 0; i < messagesTextObj.length; i++) {
                messagesTextObj[i].setText("");
            }
            for (let i = 0; i < messagesTextNextObj.length; i++) {
                messagesTextNextObj[i].setVisible(false);
            }
        });
    }
    if(sceneState == CastleState.フェードイン)
    {
        bgImg = t.add.image(SCREEN_WIDTH_CENTER, SCREEN_HEIGHT_CENTER, CASTLE_BG);
        
        char01 = t.add.sprite(385, 350, CHAR_01);
        char02 = t.add.sprite(335, 350, CHAR_02);
        char03 = t.add.sprite(435, 350, CHAR_03);
        char04 = t.add.sprite(485, 350, CHAR_04);

        char05 = t.add.sprite(385, 220, CHAR_05);
        char06 = t.add.sprite(435, 255, CHAR_06);

        char02.anims.play(UP_WALK_ANI[1]);
        char03.anims.play(UP_WALK_ANI[2]);
        char04.anims.play(UP_WALK_ANI[3]);
        char01.setFrame(12);

        t.cameras.main.fadeIn(1500, 255, 255, 255);

        se = t.sound.add(SE_STAGE_CHANGE, {volume: SE_VOLUME})
        se.play({loop:false});

        sceneState ++;
        elapsedTime = 0;

    }
    if(sceneState == CastleState.おお)
    {
        if(elapsedTime >= 1500)
        {
            displayText(delta,false,true,() => {
                bgm = t.sound.add(BGM_CASTLE, {volume: BGM_VOLUME});
                bgm.play({loop:true});
            },null);
        }
    }
    if(sceneState == CastleState.questionMark)
    {
        if (elapsedTime > 100) {
            emote = t.add.sprite(385, 295, EMOTE);
            emote.anims.play(EMOTE_QUESTION);
            
            const question = t.sound.add(SE_QUESTION, {volume: SE_VOLUME});
            question.play({loop:false})
            
            sceneState ++;
            elapsedTime = 0;
        }
    }
    if(sceneState == CastleState.えええ)
    {
        displayText(delta);
    }
    if(sceneState == CastleState.今の)
    {
        displayText(delta,true,true,() =>{
            emote.destroy();
        },null);
    }
    if(sceneState == CastleState.あぁ)
    {
        displayText(delta);
    }
    if(sceneState == CastleState.ココンカフェ)
    {
        displayText(delta,true,true,() =>{
            emote = t.add.sprite(385, 295, EMOTE);
            emote.anims.play(EMOTE_DOT);
        },() => {
            emote.destroy();
        });
    }
    if(sceneState == CastleState.え僕)
    {
        displayText(delta);
    }
    if(sceneState == CastleState.もちろん)
    {
        displayText(delta);
    }
    if(sceneState == CastleState.はい)
    {
        displayText(delta);
    }
    if(sceneState == CastleState.左右むく)
    {

        char01.anims.play(RESTLESS_ANI)
        sceneState ++;
        elapsedTime = 0;
    }
    if(sceneState == CastleState.勇者よ)
    {
        if(elapsedTime >= 2000)
        {
            displayText(delta);
        }
    }
    if(sceneState == CastleState.突然)
    {
        displayText(delta);
    }
    if(sceneState == CastleState.exclamationMark)
    {
        if (elapsedTime > 100) {
            emote = t.add.sprite(385, 295, EMOTE);
            emote.anims.play(EMOTE_EXCLAMATION);

            const exclamation = t.sound.add(SE_EXCLAMATION, {volume: SE_VOLUME});
            exclamation.play({loop:false})

            sceneState ++;
            elapsedTime = 0;
        }
    }
    if(sceneState == CastleState.しょ)
    {
        displayText(delta);
    }
    if(sceneState == CastleState.下みる)
    {
        char01.anims.play(STUNNED_ANI)
        sceneState ++;
        elapsedTime = 0;
    }
    if(sceneState == CastleState.確かに)
    {
        if(elapsedTime >= 2000)
        {
            displayText(delta,true,true,() =>{
                emote.destroy();
                emote = t.add.sprite(385, 295, EMOTE);
                emote.anims.play(EMOTE_DOT);
            },() => {
                emote.destroy();
            });
        }
    }
    if(sceneState == CastleState.さ)
    {
        displayText(delta,true,true,null,() => {
            char02.x += 10;
            char03.x -= 10;
        });
    }
    if(sceneState == CastleState.下移動)
    {
        if(elapsedTime >= 300)
        {
            char02.anims.play(DOWN_WALK_ANI[1]);
            char03.anims.play(DOWN_WALK_ANI[2]);
            char04.anims.play(DOWN_WALK_ANI[3]);

            sceneState ++;
            elapsedTime = 0;
        }
    }
    if(sceneState == CastleState.退出se)
    {
        if(elapsedTime >= 200)
        {
            char02.y += 4;
            char03.y += 4;
            char04.y += 4;
            char01.y += 4;

            if (char02.y > 700) {

                const exitSe = t.sound.add(SE_STAIRS, {volume: SE_VOLUME});
                exitSe.play({loop:false})

                sceneState ++;
                elapsedTime = 0;
            }
        }
    }
    if(sceneState == CastleState.ふぅ)
    {
        displayText(delta);
    }
    if(sceneState == CastleState.わかりません)
    {
        displayText(delta);
    }
    if(sceneState == CastleState.帰ろう)
    {
        displayText(delta);
    }
    if(sceneState == CastleState.萎えて)
    {
        displayText(delta);
    }
    if(sceneState == CastleState.まぁ)
    {
        displayText(delta);
    }
    if(sceneState == CastleState.ぴょん)
    {
        if(!jumpFlag)
        {
            jumpFlag = true;
            char05.y -= 5;
        }
        else if(elapsedTime >= 200)
        {
            char05.y += 5;
            jumpFlag = false;
            sceneState ++;
            elapsedTime = 0;
        }
    }
    if(sceneState == CastleState.いいの)
    {
        displayText(delta);
    }
    if(sceneState == CastleState.降りる)
    {
        if(char05.y < 210 && !jumpFlag)
        {
            char05.y -= 1.25;
        }
        else{
            jumpFlag = true;
            char05.y += 1.25;
            if(char05.y >= 225)
            {
                char05.y = 225;
                sceneState ++;
                elapsedTime = 0; 
            }
        }
    }
    if(sceneState == CastleState.フェードアウト)
    {
        if(elapsedTime >= DEF_STEP_NEXT)
        {
            t.cameras.main.fadeOut(1200, 0, 0, 0);
            sceneState ++;
            elapsedTime      = 0;
        }
    }
    if(sceneState == CastleState.シーン変更)
    {
        if(elapsedTime >= 1200)
        {
            msgTitle.destroy();
            messagesTextObj.forEach(element => {
                element.destroy();
            });
            messagesTextObj = [];
            messagesTextNextObj.forEach(element => {
                element.destroy();
            });
            messagesTextNextObj = [];
            msgWindow.destroy();

            char02.destroy();
            char03.destroy();
            char04.destroy();
            char01.destroy();
            char05.destroy();
            char06.destroy();

            bgImg.destroy();

            bgm.stop();
            bgm.destroy();
        
            jumpFlag = false;

            gameState = GameState.field;
        }
    }
}

/** 
 * メッセージウィンドウ初期化
 */
 function initMessageWindow(t)
{
    msgWindow = t.add.image(MESSAGE_WINDOW_X, MESSAGE_WINDOW_Y, MESSAGE);
    msgWindow.setDepth(100);
    msgTitle = t.add.text(35, 465, '',   {fontSize: FONT_SIZE, fontFamily: FONT, origin: 0});
    msgTitle.setDepth(100);
    messagesTextObj = [];
    messagesTextNextObj = [];
    for (let i = 0; i < 4; i++) {
        messagesTextObj.push(t.add.text(40, 510 + (LINE_WIDTH_SIZE * i), '',   {fontSize: FONT_SIZE, fontFamily: FONT, origin: 0}));
        messagesTextObj[i].setDepth(100);
        messagesTextNextObj.push(t.add.text(40 + FONT_SIZE * 12.5, 510 + (LINE_WIDTH_SIZE * i) + FONT_SIZE, "▼",   {fontSize: FONT_SIZE, fontFamily: FONT, origin: 0}));
        messagesTextNextObj[i].setDepth(100);
    }
}

/** 
 * オープニングシーンアップデート 
 */
function updateOpening(t)
{
    // fadeIn
    if (sceneState == 0) {
        // テキストデータ初期化
        textDataInit();

        bgImg = t.add.image(SCREEN_WIDTH_CENTER, SCREEN_HEIGHT_CENTER, OPENING_BG);

        let _message = getNextText(gameState);
        openingMsg[0] = t.add.text(200, 250, _message[1]).setFontSize(24).setFontFamily(FONT_REAL).setOrigin(0.5).setAlpha(1);
        openingMsg[1] = t.add.text(400, 300, _message[2]).setFontSize(24).setFontFamily(FONT_REAL).setOrigin(0.5).setAlpha(1);
        openingMsg[2] = t.add.text(400, 350, _message[3]).setFontSize(24).setFontFamily(FONT_REAL).setOrigin(0.5).setAlpha(1);
        openingMsg[3] = t.add.text(400, 400, _message[4]).setFontSize(24).setFontFamily(FONT_REAL).setOrigin(0.5).setAlpha(1);

        for (var i = 0; i < 4; i++) {
            openingMsgTween[i] = null;
        }

        sceneState ++;
        elapsedTime      = 0;
    }
    
    if (sceneState == 1) {

        if(inputPointer.isDown) {
            openingMsg[0].setAlpha(0);
            openingMsg[1].setAlpha(0);
            openingMsg[2].setAlpha(0);
            openingMsg[3].setAlpha(0);

            bgm = t.sound.add(BGM_OPENING, {volume: BGM_VOLUME_OPENING});
            bgm.play({loop:true});

            sceneState ++;
            elapsedTime      = 3000;
    	}
    }

    if(sceneState == 2)
    {
        // クリックでメッセージを飛ばす
        if (isClick) {
            isClick = false;
            elapsedTime += (DEF_OPENING_STEP_NEXT+DEF_OPENING_STEP_DISP);
            for(var i = 0; i < 4; i++) {
                if (openingMsgTween[i]) {
                    openingMsgTween[i]?.destroy();
                }
            }
        }

        if(openingMessageIndex < getTextSize(gameState) - 1){
            if(isOpeningMessageText)
            {
                displayOpeningText(t);
            }
            else if(isOpeningMessageWait){
                displayOpeningTextWait(t);
            }
        }
        else
        {
            sceneState++;
        }
    }

    if (sceneState == 3) {
        if (elapsedTime > DEF_OPENING_STEP_NEXT) {
            t.cameras.main.fadeOut(1200, 255, 255, 255);
            
            // BGM フェードアウト
            t.tweens.add({
                targets:  bgm,
                volume:   0,
                duration: 500
            });

            sceneState ++;
            elapsedTime      = 0;
        }
    }
    if (sceneState == 4) {
        if (elapsedTime > DEF_OPENING_STEP_NEXT) {

            // BGM 停止
            bgm.stop();
            bgm.destroy();

            gameState = GameState.castle;
        }
    }
}

/**
 * オープニングテキスト表示
 */
function displayOpeningText(t)
{
    if (elapsedTime > DEF_OPENING_STEP_NEXT) {
        let _message = getNextText(gameState);
        openingMsg[0].setText(_message[1]);
        openingMsg[1].setText(_message[2]);
        openingMsg[2].setText(_message[3]);
        openingMsg[3].setText(_message[4]);


        for(var i = 0; i < 4; i++) {
            openingMsgTween[i] = t.tweens.add({
                targets: openingMsg[i],
                alpha: 1,
                duration: 3000,
                ease: TWEEN_CASE_POWER2
            }, t);
        }
       
        if(_message[0] === 'fade_out'){
            isOpeningMessageText = false;
            isOpeningMessageWait = true;
        }
        else{
            isOpeningMessageText = true;
            isOpeningMessageWait = false;
        }

        openingMessageIndex++;
        elapsedTime      = 0;
    }
}
/**
 * フェード
 */
function displayOpeningTextWait(t)
{
    if (elapsedTime > DEF_OPENING_STEP_DISP) {
        for(var i = 0; i < 4; i++) {
            openingMsgTween[i] = t.tweens.add({
                targets: openingMsg[i],
                alpha: 0,
                duration: 1500,
                ease: TWEEN_CASE_POWER2
            }, t);
        }

        isOpeningMessageText = true;
        isOpeningMessageWait = false;
        elapsedTime      = 0;
    }
}
/** 
 * 指定フォントが有効になるまでの待機期間
 */
 function updateInitFont(t)
{
    // fadeIn
    if (sceneState == 0) {
        //
        t.add.text(-100, -100, "▼あいうえお▼").setFontSize(20).setFontFamily(FONT).setOrigin(0).setAlpha(0);
        t.add.text(-100, -100, "▼あいうえお▼").setFontSize(20).setFontFamily(FONT_REAL).setOrigin(0).setAlpha(0);

        bgImg = t.add.image(SCREEN_WIDTH_CENTER, SCREEN_HEIGHT_CENTER, OPENING_BG);

        sceneState ++;
        elapsedTime      = 0;
    }
    if (sceneState == 1) {
        if (elapsedTime > 100) {
            gameState = GameState.opening;
        }
    }
}
/**
 * テキスト表示 
 */
function displayText(delta,startSe = true,waitNext = true, startFunc = null , endFunc = null)
{
    // メッセージ表示部分初期化とメッセージ取得
    if(!message)
    {
        // 前処理関数が設定されていたら実行
        startFunc?.();

        message = getNextText(gameState);
        msgTitle.setText(message[TEXT_TITLE])
        messagesTextObj.forEach(text => {
            if(text) text.setText("");
        });
        if(startSe)
        {
            messageSe2.play({loop:false});
        }

        for (let i = 0; i < messagesTextNextObj.length; i++) {
            messagesTextNextObj[i].setVisible(false);
        }
    }

    if (displaySlowText(message.slice(1, message.length),delta))
    {
        if(waitNext)
        {
            messageEndFunc = endFunc;
            isMessageWait = true;
        }
        else{
            endFunc?.();
            messageMoji = 0;
            currentLine = 0;
            message = null;
            elapsedTime = 0;
            sceneState++;
        }
    }
}

/**
 * テキストをゆっくり表示する
 * @param text テキストオブジェクト
 * @param value 表示するテキスト
 * 
 * @return true クリックするまで止まる　false 会話中
 */
function displaySlowText(value,delta)
{
    textElapsedTime += delta;
    if (inputPointer.isDown && isClick) 
    {
        isClick = false;

        currentLine = value.length - 1;
        messageMoji = value[currentLine].length;
        
        for (let i = 0; i < messagesTextObj.length; i++) {
            if(value[i] == undefined) {
                messagesTextNextObj[i-1].setVisible(true);
                break;
            }
            messagesTextObj[i].setText(value[i]);
        }

        if(messageSe1){
            messageSe1.play({loop:false});
        }

        return true;
    } 
    else if (textElapsedTime > DEF_MOJI_SPEED && messageMoji < value[currentLine].length && currentLine < value.length) {
        textElapsedTime = 0;

        // スペースと改行は音を出さないし、文字送りもしない
        do {
            messageMoji ++;
            var wTxt = value[currentLine].slice(0, messageMoji);
            messagesTextObj[currentLine].setText(wTxt);
        } while(wTxt.slice(-1) == ' ' || wTxt.slice(-1) == "\n")

        if(messageSe1){
            messageSe1.play({loop:false});
        }

        if(value[currentLine] == wTxt && currentLine >= value.length - 1)
        {
            messagesTextNextObj[currentLine].setVisible(true);
            return true;
        }
        else{
            // 今表示している行が終われば次の行に移行
            if(value[currentLine] == wTxt)
            {
                currentLine++;
                messageMoji = 0;
            }

            return false;
        }
    }
}
